"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { ChevronDownIcon } from "lucide-react"

export default function ReviewsHoverMenu() {
  const pathname = usePathname()
  const isActive =
    pathname === "/reviews" ||
    pathname === "/comparisons" ||
    pathname === "/buying-guides" ||
    pathname.startsWith("/reviews/")
  return (
    <div
      style={{ fontFamily: "Helvetica Neue" }}
      className="group relative flex items-center"
    >
      <Link
        href="/reviews"
        aria-current={isActive ? "page" : undefined}
        className={`flex h-9 items-center gap-1 rounded-lg p-2 text-[14px] font-medium hover:opacity-70 ${isActive ? "text-[#0f9e4f]" : "text-[#4E5969]"}`}
      >
        Reviews
        <ChevronDownIcon size={16} aria-hidden="true" />
      </Link>

      <div className="invisible absolute top-full left-0 z-50 w-[153px] pt-2 opacity-0 transition-all group-focus-within:visible group-focus-within:opacity-100 group-hover:visible group-hover:opacity-100">
        <div className="rounded-[10px] bg-white py-2 shadow-[0_8px_24px_rgba(0,0,0,0.12)]">
          <Link
            href="/comparisons"
            className="block px-4 py-2 text-[14px] font-medium text-[#1D2129] hover:bg-[#F2F3F5]"
          >
            Comparisons
          </Link>

          <Link
            href="/buying-guides"
            className="block px-4 py-2 text-[14px] font-medium text-[#1D2129] hover:bg-[#F2F3F5]"
          >
            Buying Guides
          </Link>
        </div>
      </div>
    </div>
  )
}
